import { request } from ".";

export const wordStatsApi = {
  getAll: (queryParams: string) => request("/wordstats/me"+queryParams),
  hide: (words: number[]) => request("/wordstats/block", words.map(word => ({ word }))),
  show: (words: number[]) => request("/wordstats/unblock", words.map(word => ({ word }))),
}